module.exports = __webpack_public_path__ + "static/img/logo_1.d7fd927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_1.png
// module id = lUua
// module chunks = 3